"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("@fluentui/react");
var react_2 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var loadingSpinner_1 = require("../loadingSpinner");
require("./ComboBoxItemPanel.scss");
var Pagination_1 = __importDefault(require("../customDetailList/Pagination"));
var ErrorPanel_1 = require("./ErrorPanel");
var NoRecordPanel_1 = require("./NoRecordPanel");
var mapStateToProps = function (state) { return ({
    currentLanguage: state.reduxlanguage.language,
}); };
var mapDispatchToProps = {};
var connector = react_redux_1.connect(mapStateToProps, mapDispatchToProps);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
exports.ItemPanelDataContext = react_2.createContext({ url: '', isLoading: false, nbItems: 0, totalItems: 0, searchText: '', mode: 'Search' });
var ComboBoxItemPanel = function (props) {
    var children = props.children, currentLanguage = props.currentLanguage, onNavigate = props.onNavigate, customLabelResource = props.customLabelResource;
    var memorizePosition = react_2.useRef();
    var isLoading = props.isLoading, nbItems = props.nbItems, totalItems = props.totalItems, mode = props.mode, url = props.url, searchComboBoxState = props.searchComboBoxState, paginationSetting = props.paginationSetting, onShowFrequentlyUsedLink = props.onShowFrequentlyUsedLink, customNoRecordPanel = props.customNoRecordPanel, showFrequentlyUsedLink = props.showFrequentlyUsedLink, errorMessage = props.errorMessage, onchangeFilter = props.onchangeFilter, showCannotFindPanel = props.showCannotFindPanel; // useContext(ItemPanelDataContext);
    var t = react_i18next_1.useTranslation('SearchComboBox').t;
    react_2.useLayoutEffect(function () {
        var prefixElements = document.getElementsByClassName('searchComboBoxPrefix');
        if (prefixElements.length > 0) {
            var prefixElement_1 = prefixElements[0];
            if (prefixElement_1) {
                setTimeout(function () {
                    var prefixWidth = prefixElement_1.clientWidth;
                    var elements = document.getElementsByClassName('ms-ComboBox-callout');
                    var divElement = elements[0];
                    if (divElement) {
                        if (currentLanguage.isRtl) {
                            var currentLeft = Number.parseFloat(divElement.style.left.replace('px', ''));
                            if (memorizePosition.current !== currentLeft) {
                                memorizePosition.current = Number.parseFloat((currentLeft + prefixWidth).toFixed(3));
                                divElement.style.left = (memorizePosition.current) + "px";
                            }
                        }
                        else {
                            var currentRight = Number.parseFloat(divElement.style.right.replace('px', ''));
                            if (memorizePosition.current !== currentRight) {
                                memorizePosition.current = Number.parseFloat((currentRight + prefixWidth).toFixed(3));
                                divElement.style.right = (memorizePosition.current) + "px";
                            }
                        }
                    }
                }, 1);
            }
        }
    });
    var pageInfo = (paginationSetting === null || paginationSetting === void 0 ? void 0 : paginationSetting.currentPage) != null &&
        (paginationSetting === null || paginationSetting === void 0 ? void 0 : paginationSetting.totalPage) != null
        ? __assign(__assign({}, searchComboBoxState === null || searchComboBoxState === void 0 ? void 0 : searchComboBoxState.pageInfo), { currentPage: paginationSetting.currentPage, totalPage: paginationSetting.totalPage, paginationSetting: (searchComboBoxState === null || searchComboBoxState === void 0 ? void 0 : searchComboBoxState.pageInfo) ? searchComboBoxState.pageInfo.paginationSetting
                : paginationSetting }) : searchComboBoxState === null || searchComboBoxState === void 0 ? void 0 : searchComboBoxState.pageInfo;
    var NoRecordComponent = customNoRecordPanel !== null && customNoRecordPanel !== void 0 ? customNoRecordPanel : NoRecordPanel_1.NoRecordPanel;
    return (react_2.default.createElement("div", { className: 'comboBoxItemPanel' }, isLoading && nbItems === 0 ? (react_2.default.createElement("div", { className: 'loading' },
        react_2.default.createElement(loadingSpinner_1.LoadingSpinner, { messageLabel: t('SearchInProgress') }))) :
        (react_2.default.createElement(react_2.default.Fragment, null,
            nbItems === 0 ?
                (react_2.default.createElement(react_2.default.Fragment, null, (errorMessage !== null && errorMessage !== void 0 ? errorMessage : '') !== '' ?
                    react_2.default.createElement(ErrorPanel_1.ErrorPanel, { errorMessage: errorMessage, onchangeFilter: onchangeFilter }) : (react_2.default.createElement(NoRecordComponent, { url: url !== null && url !== void 0 ? url : '', showCannotFindPanel: showCannotFindPanel, onShowFrequentlyUsedLink: onShowFrequentlyUsedLink, showFrequentlyUsedLink: showFrequentlyUsedLink }))))
                : (react_2.default.createElement(react_2.default.Fragment, null,
                    react_2.default.createElement("div", { className: 'comboBoxPanelHeader' }, mode === 'Search' ? (react_2.default.createElement(react_2.default.Fragment, null, (pageInfo && pageInfo.totalPage > 0) ? (react_2.default.createElement(react_1.Label, { className: 'topResult' }, t(customLabelResource !== null && customLabelResource !== void 0 ? customLabelResource : 'TotalResult', { total: totalItems }))) : (react_2.default.createElement(react_2.default.Fragment, null,
                        react_2.default.createElement(react_1.Label, { className: 'topResult' },
                            t(customLabelResource !== null && customLabelResource !== void 0 ? customLabelResource : 'TopResult', { total: nbItems }),
                            " "),
                        totalItems !== nbItems && (react_2.default.createElement(react_1.Label, null,
                            "(",
                            t(customLabelResource !== null && customLabelResource !== void 0 ? customLabelResource : 'TotalResult', { total: totalItems }),
                            ")")))))) :
                        (react_2.default.createElement(react_1.Label, { className: 'topResult' },
                            t('FrequentlyUsed'),
                            " "))),
                    children,
                    pageInfo &&
                        mode === 'Search' &&
                        pageInfo.totalPage > 0 && (react_2.default.createElement(Pagination_1.default, { itemsPerPage: pageInfo.paginationSetting.nbItemPerPage, currentPageIndex: pageInfo.currentPage, totalPageCount: pageInfo.totalPage, labels: {
                            resultPerPage: undefined,
                            totalRecord: undefined,
                        }, totalRecordCount: totalItems, nbPagesShown: pageInfo.paginationSetting.nbPageShown, onNavigate: onNavigate })))),
            isLoading && (react_2.default.createElement("div", { className: 'eta-ItemPanelLoadingPanel' },
                react_2.default.createElement("div", { className: 'eta-ItemPanelLoadingItem' },
                    react_2.default.createElement(loadingSpinner_1.LoadingSpinner, { messageLabel: t('loading') }))))))));
};
exports.default = connector(ComboBoxItemPanel);
//# sourceMappingURL=ComboBoxItemPanel.js.map